// extracted by mini-css-extract-plugin
module.exports = {"container":"InputBox_container__sRV73","label":"InputBox_label__3857f","sublabel":"InputBox_sublabel__1-_93","error":"InputBox_error__1Zq5J","input":"InputBox_input__rJmry"};